import React, { useState, useEffect, useContext } from 'react';
import { LocalizationContext } from '../App';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { BrowserView, MobileView, isDesktop, isMobile } from 'react-device-detect';
import Grid from '@mui/material/Grid';
import { alpha, styled } from '@mui/material/styles';
import env from "react-dotenv";
import { ThemeProvider, useTheme, createTheme } from '@mui/material/styles';
import { ReactSession } from 'react-client-session';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import axios from 'axios';
import uuid from 'react-uuid';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';

import { WorldMap } from 'grommet';
import { Box, Card, CardBody, CardFooter, CardHeader, Text } from 'grommet';

function LoupeAbout(props) {

    const localizer = useContext(LocalizationContext);
    const defLang = localizer.getLanguage();

    const [ hasContent, setHasContent ] = React.useState(false);
    const [ retrievedContent, setRetrievedContent ] = React.useState("");

    const updateContent = () => {
        
        let uri = process.env.REACT_APP_SERVICE_URI + '/api/getHubContentUpdates/' + defLang;  
        axios.get(uri, 
            {
            withCredentials: true,
            headers: {
                 "Content-Type": "application/x-www-form-urlencoded",
                 'LOUPE-USR-KEY' : ReactSession.get("userid"),
                 'LOUPE-API-KEY' : 'APIKEY2',
            }

        }).then(res => { 
            
            if ( res.data != "" ) 
            {                
                console.log(res.data);
                var contentUpdate = res.data;                                       
                setRetrievedContent(contentUpdate);
                setHasContent(true);
            }
            else
            {
                setRetrievedContent("");
                setHasContent(false);
            }


        }).catch(error => {
            setRetrievedContent("");
            setHasContent(false);
        });

       
    };

    useEffect(() => {        
        updateContent();
    }, [defLang]);

    return (
        
        <LocalizationContext.Consumer>

            { ({strings}) =>
            
                <Paper className="padding">  
                   
                    <div className="container padding">
                                                             

                        { (hasContent === false) ? 
                            (<>
                                <Typography variant="h5" gutterBottom component="div">{strings.getString("texts.titles.help")}</Typography>
                                <Divider className="tbm"/>
                                <Typography variant="body2" gutterBottom component="div" className="mb-8">
                                    {strings.getString("texts.about.loupe.cstool")}
                                </Typography>
                                <Typography variant="body" gutterBottom component="div" className="mb-3">
                                    {strings.getString("texts.about.loupe.csfindings")}
                                </Typography>
                            </>) :
                            (<>

                                {( retrievedContent != "" && Array.isArray(retrievedContent) && retrievedContent.length > 0 ) ? (
                                    <React.Fragment>
                                        {retrievedContent.map(row => {                                                                  
                                            return(
                                                <div key={uuid()}>

                                                    { row.type == "title" && 
                                                        <Typography style={{ textAlign : 'left' }} variant="h4" gutterBottom component="div" className="mb-5">
                                                            {row.item}
                                                        </Typography> 
                                                    }     

                                                    { row.type == "text" && 
                                                        <Typography style={{ textAlign : 'left' }} variant="body" gutterBottom component="div" className="mb-3">
                                                            {row.item}
                                                        </Typography>                                                                                                               
                                                    }  

                                                    { row.type == "survey-count" && 
                                                        <Paper style={{ color : 'white' }} className="loupe-gradient padding mb-6" elevation="8">                                                           
                                                            <Typography style={{textAlign : 'center' }} variant="h3" component="div">
                                                                {row.item}
                                                            </Typography>  
                                                            <Typography style={{ textAlign : 'center' }} variant="body" gutterBottom component="div">
                                                                {strings.getString("aboutstrings.count")}
                                                            </Typography>                                                                
                                                        </Paper>
                                                    }  

                                                    { row.type == "survey-responses" && 
                                                        <Paper className="padding" elevation="8">
                                                            <Typography style={{textAlign : 'center' }} variant="h3" component="div">
                                                                {row.item}
                                                            </Typography>   
                                                            <Typography style={{ textAlign : 'center' }} variant="body" gutterBottom component="div">
                                                                {row.caption}
                                                            </Typography> 
                                                        </Paper>                                                        
                                                    }  

                                                    { row.type == "survey-sites" && 
                                                        <Paper className="padding" elevation="8">
                                                            <Typography style={{textAlign : 'center' }} variant="h3" component="div">
                                                                {row.item}
                                                            </Typography>  
                                                            <Typography style={{ textAlign : 'center' }} variant="body" gutterBottom component="div">
                                                                {strings.getString("aboutstrings.geofences")}
                                                            </Typography>  
                                                        </Paper>
                                                    }  
                                                    
                                                    { row.type == "image" && 
                                                        <Card className="mb-6">
                                                            <CardBody>
                                                            <img src={`${process.env.REACT_APP_SERVICE_URI}/resources/images/${row.item}`}></img> 

                                                            </CardBody>
                                                            <CardFooter pad="small">

                                                            <Typography style={{textAlign : 'center'}} variant="caption" component="div">
                                                                {row.caption}
                                                            </Typography>   
                                                            </CardFooter>
                                                        </Card>
                                                    }   

                                                    { row.type == "spacing" &&
                                                        <p style={{ marginBottom : `${row.item}cm` }}></p>
                                                    }
                                                    
                                                    { row.type == "ovmap" &&
                                                        
                                                        <React.Fragment>
                                                            <Box pad="large" gap="medium">
                                                               
                                                                <WorldMap   
                                                                    alignSelf='stretch'
                                                                    margin="none"                         
                                                                    places={ row.item.map(i => {                                                                
                                                                        var currentLocation = i;
                                                                        i.onClick = (name) => {};                                                                
                                                                        return(i);
                                                                    }) }                            
                                                                    color='#cccccc' />
                                                                    <p> {strings.getString("aboutstrings.places")}</p>
                                                                {row.item.map(i => {
                                                                    return(
                                                                        <p><Button rel='norefferer' target="_blank" key={uuid()} href={i.link}>{i.name}</Button></p>
                                                                    );                                                           
                                                                })}
                                                                   
                                                            </Box>
                                                           
                                                        </React.Fragment>
                                                        
                                                        
                                                    }

                                                </div>
                                            );                                      
                                        })}
                                    </React.Fragment>

                                ) : (

                                    <Typography variant="body" gutterBottom component="div" className="mb-3">
                                        {strings.getString("texts.about.loupe.csfindings")}
                                    </Typography>

                                ) }
   
                            </>) 

                        }
                        


                    </div>

                  
                </Paper>
            }
        </LocalizationContext.Consumer>
    );
}

export default LoupeAbout;